import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '../base-api.service';
import { Country } from '../../model/country';

@Injectable({
  providedIn: 'root'
})
export class CountryService extends BaseApiService<Country, string> {
  protected endpoint = '/country';

  constructor(protected override http: HttpClient) {
    super(http);
  }
}
